// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IStateInfoDto } from './IStateInfoDto';
import {
    IStateInfoDtoFromJSON,
    IStateInfoDtoFromJSONTyped,
    IStateInfoDtoToJSON,
    IStateInfoDtoToJSONTyped,
} from './IStateInfoDto';
import type { ICountryInfoDto } from './ICountryInfoDto';
import {
    ICountryInfoDtoFromJSON,
    ICountryInfoDtoFromJSONTyped,
    ICountryInfoDtoToJSON,
    ICountryInfoDtoToJSONTyped,
} from './ICountryInfoDto';

/**
 * 
 * @export
 * @interface ITransactorAddressInfoDto
 */
export interface ITransactorAddressInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ITransactorAddressInfoDto
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ITransactorAddressInfoDto
     */
    validated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ITransactorAddressInfoDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof ITransactorAddressInfoDto
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ITransactorAddressInfoDto
     */
    line3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ITransactorAddressInfoDto
     */
    line4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ITransactorAddressInfoDto
     */
    city: string;
    /**
     * 
     * @type {IStateInfoDto}
     * @memberof ITransactorAddressInfoDto
     */
    state: IStateInfoDto;
    /**
     * 
     * @type {string}
     * @memberof ITransactorAddressInfoDto
     */
    zipcode: string;
    /**
     * 
     * @type {ICountryInfoDto}
     * @memberof ITransactorAddressInfoDto
     */
    country: ICountryInfoDto;
}

/**
 * Check if a given object implements the ITransactorAddressInfoDto interface.
 */
export function instanceOfITransactorAddressInfoDto(value: object): value is ITransactorAddressInfoDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function ITransactorAddressInfoDtoFromJSON(json: any): ITransactorAddressInfoDto {
    return ITransactorAddressInfoDtoFromJSONTyped(json, false);
}

export function ITransactorAddressInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITransactorAddressInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'validated': json['validated'] == null ? undefined : json['validated'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'line4': json['line4'] == null ? undefined : json['line4'],
        'city': json['city'],
        'state': IStateInfoDtoFromJSON(json['state']),
        'zipcode': json['zipcode'],
        'country': ICountryInfoDtoFromJSON(json['country']),
    };
}

export function ITransactorAddressInfoDtoToJSON(json: any): ITransactorAddressInfoDto {
    return ITransactorAddressInfoDtoToJSONTyped(json, false);
}

export function ITransactorAddressInfoDtoToJSONTyped(value?: ITransactorAddressInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'validated': value['validated'],
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'line4': value['line4'],
        'city': value['city'],
        'state': IStateInfoDtoToJSON(value['state']),
        'zipcode': value['zipcode'],
        'country': ICountryInfoDtoToJSON(value['country']),
    };
}

